export interface RequestState<T = any> {
  loading: boolean;
  response: T | null;
  error: any | null;
  message?: string | null;
}

export interface SupplierDashboardState {
  dashboard: RequestState;
  applications: RequestState;
  viewApplication: RequestState;
  revokeSupplierPrequalification: RequestState;
}

export const initialSupplierDashboardState: SupplierDashboardState = {
  dashboard: {
    loading: false,
    response: null,
    error: null,
    message: null,
  },
  applications: {
    loading: false,
    response: null,
    error: null,
    message: null,
  },
  viewApplication: {
    loading: false,
    response: null,
    error: null,
    message: null,
  },
  revokeSupplierPrequalification: {
    loading: false,
    response: null,
    error: null,
    message: null,
  },
};

